class DMACodes {

    // constructor(){
    // }

    static DMACodeLabels: string[][] = [
        ['881','SPOKANE'],
        ['868','CHICO-REDDING'],
        ['866','FRESNO-VISALIA'],
        ['862','SACRAMENTO-STOCKTON-MODESTO'],
        ['855','SANTA BARBARA-SANTA MARIA-SAN LUIS OBISPO'],
        ['839','LAS VEGAS'],
        ['828','MONTEREY-SALINAS'],
        ['825','SAN DIEGO'],
        ['821','BEND'],
        ['820','PORTLAND'],
        ['819','SEATTLE-TACOMA'],
        ['813','MEDFORD-KLAMATH FALLS'],
        ['811','RENO'],
        ['810','YAKIMA-PASCO-RICHLAND-KENNEWICK'],
        ['807','SAN FRANCISCO-OAKLAND-SAN JOSE'],
        ['804','PALM SPRINGS'],
        ['803','LOS ANGELES'],
        ['802','EUREKA'],
        ['801','EUGENE'],
        ['800','BAKERSFIELD'],
        ['798','GLENDIVE'],
        ['790','ALBUQUERQUE-SANTA FE'],
        ['789','TUCSON (SIERRA VISTA)'],
        ['773','GRAND JUNCTION-MONTROSE'],
        ['771','YUMA-EL CENTRO'],
        ['770','SALT LAKE CITY'],
        ['767','CASPER-RIVERTON'],
        ['766','HELENA'],
        ['765','EL PASO (LAS CRUCES)'],
        ['764','RAPID CITY'],
        ['762','MISSOULA'],
        ['760','TWIN FALLS'],
        ['759','CHEYENNE-SCOTTSBLUFF'],
        ['758','IDAHO FALLS-POCATELLO'],
        ['757','BOISE'],
        ['756','BILLINGS'],
        ['755','GREAT FALLS'],
        ['754','BUTTE-BOZEMAN'],
        ['753','PHOENIX (PRESCOTT)'],
        ['752','COLORADO SPRINGS-PUEBLO'],
        ['751','DENVER'],
        ['749','LAREDO'],
        ['747','JUNEAU'],
        ['746','BILOXI-GULFPORT'],
        ['745','FAIRBANKS'],
        ['744','HONOLULU'],
        ['743','ANCHORAGE'],
        ['740','NORTH PLATTE'],
        ['737','MANKATO'],
        ['736','BOWLING GREEN'],
        ['734','JONESBORO'],
        ['725','SIOUX FALLS (MITCHELL)'],
        ['724','FARGO-VALLEY CITY'],
        ['722','LINCOLN & HASTINGS-KEARNEY PLUS'],
        ['718','JACKSON'],
        ['717','QUINCY-HANNIBAL-KEOKUK'],
        ['716','BATON ROUGE'],
        ['711','MERIDIAN'],
        ['710','HATTIESBURG-LAUREL'],
        ['709','TYLER-LONGVIEW (LUFKIN & NACOGDOCHES)'],
        ['705','WAUSAU-RHINELANDER'],
        ['702','LA CROSSE-EAU CLAIRE'],
        ['698','MONTGOMERY-SELMA'],
        ['693','LITTLE ROCK-PINE BLUFF'],
        ['692','BEAUMONT-PORT ARTHUR'],
        ['691','HUNTSVILLE-DECATUR (FLORENCE)'],
        ['687','MINOT-BISMARCK-DICKINSON (WILLISTON)'],
        ['686','MOBILE, AL-PENSACOLA (FT. WALTON BEACH)'],
        ['682','DAVENPORT-ROCK ISLAND-MOLINE'],
        ['679','DES MOINES-AMES'],
        ['678','WICHITA-HUTCHINSON PLUS'],
        ['676','DULUTH-SUPERIOR'],
        ['675','PEORIA-BLOOMINGTON'],
        ['673','COLUMBUS-TUPELO-WEST POINT'],
        ['671','TULSA'],
        ['670','FT. SMITH-FAYETTEVILLE-SPRINGDALE-ROGERS'],
        ['669','MADISON'],
        ['662','ABILENE-SWEETWATER'],
        ['661','SAN ANGELO'],
        ['659','NASHVILLE'],
        ['658','GREEN BAY-APPLETON'],
        ['657','SHERMAN-ADA'],
        ['656','PANAMA CITY'],
        ['652','OMAHA'],
        ['651','LUBBOCK'],
        ['650','OKLAHOMA CITY'],
        ['649','EVANSVILLE'],
        ['648','CHAMPAIGN & SPRINGFIELD-DECATUR'],
        ['647','GREENWOOD-GREENVILLE'],
        ['644','ALEXANDRIA'],
        ['643','LAKE CHARLES'],
        ['642','LAFAYETTE'],
        ['641','SAN ANTONIO'],
        ['640','MEMPHIS'],
        ['639','JACKSON'],
        ['638','ST. JOSEPH'],
        ['637','CEDAR RAPIDS-WATERLOO-IOWA CITY & DUBUQUE'],
        ['636','HARLINGEN-WESLACO-BROWNSVILLE-MCALLEN'],
        ['635','AUSTIN'],
        ['634','AMARILLO'],
        ['633','ODESSA-MIDLAND'],
        ['632','PADUCAH-CAPE GIRARDEAU-HARRISBURG'],
        ['631','OTTUMWA, IA-KIRKSVILLE'],
        ['630','BIRMINGHAM (ANNISTON AND TUSCALOOSA)'],
        ['628','MONROE, LA-EL DORADO'],
        ['627','WICHITA FALLS & LAWTON'],
        ['626','VICTORIA'],
        ['625','WACO-TEMPLE-BRYAN'],
        ['624','SIOUX CITY'],
        ['623','DALLAS-FORT WORTH'],
        ['622','NEW ORLEANS'],
        ['619','SPRINGFIELD'],
        ['618','HOUSTON'],
        ['617','MILWAUKEE'],
        ['616','KANSAS CITY'],
        ['613','MINNEAPOLIS-ST. PAUL'],
        ['612','SHREVEPORT'],
        ['611','ROCHESTER-MASON CITY-AUSTIN'],
        ['610','ROCKFORD'],
        ['609','ST. LOUIS'],
        ['606','DOTHAN'],
        ['605','TOPEKA'],
        ['604','COLUMBIA-JEFFERSON CITY'],
        ['603','JOPLIN-PITTSBURG'],
        ['602','CHICAGO'],
        ['600','CORPUS CHRISTI'],
        ['598','CLARKSBURG-WESTON'],
        ['597','PARKERSBURG'],
        ['596','ZANESVILLE'],
        ['592','GAINESVILLE'],
        ['588','SOUTH BEND-ELKHART'],
        ['584','CHARLOTTESVILLE'],
        ['583','ALPENA'],
        ['582','LAFAYETTE'],
        ['581','TERRE HAUTE'],
        ['577','WILKES-BARRE-SCRANTON'],
        ['576','SALISBURY'],
        ['575','CHATTANOOGA'],
        ['574','JOHNSTOWN-ALTOONA'],
        ['573','ROANOKE-LYNCHBURG'],
        ['571','FT. MYERS-NAPLES'],
        ['570','MYRTLE BEACH-FLORENCE'],
        ['569','HARRISONBURG'],
        ['567','GREENVILLE-SPARTANBURG-ASHEVILLE-ANDERSON'],
        ['566','HARRISBURG-LANCASTER-LEBANON-YORK'],
        ['565','ELMIRA (CORNING)'],
        ['564','CHARLESTON-HUNTINGTON'],
        ['563','GRAND RAPIDS-KALAMAZOO-BATTLE CREEK'],
        ['561','JACKSONVILLE'],
        ['560','RALEIGH-DURHAM (FAYETTEVILLE)'],
        ['559','BLUEFIELD-BECKLEY-OAK HILL'],
        ['558','LIMA'],
        ['557','KNOXVILLE'],
        ['556','RICHMOND-PETERSBURG'],
        ['555','SYRACUSE'],
        ['554','WHEELING-STEUBENVILLE'],
        ['553','MARQUETTE'],
        ['552','PRESQUE ISLE'],
        ['551','LANSING'],
        ['550','WILMINGTON'],
        ['549','WATERTOWN'],
        ['548','WEST PALM BEACH-FT. PIERCE'],
        ['547','TOLEDO'],
        ['546','COLUMBIA'],
        ['545','GREENVILLE-NEW BERN-WASHINGTON'],
        ['544','NORFOLK-PORTSMOUTH-NEWPORT NEWS'],
        ['543','SPRINGFIELD-HOLYOKE'],
        ['542','DAYTON'],
        ['541','LEXINGTON'],
        ['540','TRAVERSE CITY-CADILLAC'],
        ['539','TAMPA-ST. PETERSBURG (SARASOTA)'],
        ['538','ROCHESTER'],
        ['537','BANGOR'],
        ['536','YOUNGSTOWN'],
        ['535','COLUMBUS'],
        ['534','ORLANDO-DAYTONA BEACH-MELBOURNE'],
        ['533','HARTFORD & NEW HAVEN'],
        ['532','ALBANY-SCHENECTADY-TROY'],
        ['531','TRI-CITIES, TN-VA'],
        ['530','TALLAHASSEE-THOMASVILLE'],
        ['529','LOUISVILLE'],
        ['528','MIAMI-FT. LAUDERDALE'],
        ['527','INDIANAPOLIS'],
        ['526','UTICA'],
        ['525','ALBANY'],
        ['524','ATLANTA'],
        ['523','BURLINGTON PLATTSBURGH'],
        ['522','COLUMBUS'],
        ['521','PROVIDENCE-NEW BEDFORD'],
        ['520','AUGUSTA'],
        ['519','CHARLESTON'],
        ['518','GREENSBORO-HIGH POINT-WINSTON-SALEM'],
        ['517','CHARLOTTE'],
        ['516','ERIE'],
        ['515','CINCINNATI'],
        ['514','BUFFALO'],
        ['513','FLINT-SAGINAW-BAY CITY'],
        ['512','BALTIMORE'],
        ['511','WASHINGTON, DC (HAGERSTOWN)'],
        ['510','CLEVELAND-AKRON (CANTON)'],
        ['509','FT. WAYNE'],
        ['508','PITTSBURGH'],
        ['507','SAVANNAH'],
        ['506','BOSTON (MANCHESTER)'],
        ['505','DETROIT'],
        ['504','PHILADELPHIA'],
        ['503','MACON'],
        ['502','BINGHAMTON'],
        ['501','NEW YORK'],
        ['500','PORTLAND-AUBURN'],
        ['498','NORTHERN MARIANA ISLANDS'],
        ['495','GUAM'],
        ['493','AMERICAN SAMOA'],
        ['491','VIRGIN ISLANDS'],
        ['490','PUERTO RICO']
    ];

    static DMACodeToLabel: Map<string, string> = new Map<string, string>(DMACodes.DMACodeLabels as any);

    static getLabel(dmaCode: string): string | null {
        const label = DMACodes.DMACodeToLabel.get(dmaCode);
        return label ? label : null;
    }
}

export {DMACodes};

